
import React, { useEffect, useState } from "react";
import TravelersIcon from "../assets/media/icons/traveler.png";
import SuccessFullTripIcon from "../assets/media/icons/road-trip.png";
import BikeIcon from "../assets/media/icons/motorcycle.png";
import CorporateIcon from "../assets/media/icons/manager.png";
import OrganizedFileIcon from "../assets/media/icons/database-file.png";
import ReviewsIcon from "../assets/media/icons/customer-review.png";
import AboutUsAPI from "../api/AboutUsAPI";

const items = [
  {
    icon: TravelersIcon,
    label: "Engaging, experienced trip leaders",
  },
  {
    icon: SuccessFullTripIcon,
    label: "⁠Pan-India family, corporate & group tours",
  },
  {
    icon: BikeIcon,
    label: "Proactive, dedicated support",
  },
  {
    icon: CorporateIcon,
    label: "⁠Safety-led travel planning",
  },
  {
    icon: OrganizedFileIcon,
    label: "⁠Tried & tested, seamless itineraries",
  },
  {
    icon: ReviewsIcon,
    label: "⁠Locally vetted, trusted stays",
  },
];

const WhySortedTrips = ({data}) => {

  return (
    <div className="custom-why-sorted-trips container-fluid mb-2 bg-light">
      <div className="row">
        <div
          className="col-md-6 col-lg-6 pt-5 ps-5 custom-why-sorted-trips-left-part text-center"
          style={{ backgroundColor: "#edf7fb" }}
        >
          <div className="row justify-content-center align-items-center">
            {items.map((item, idx) => (
              <div
                key={idx}
                className="col-6 col-md-4 mb-4 d-flex flex-column align-items-center custom-why-sorted-trips-left-part-left-box"
                style={{ minHeight: "160px" }}
              >
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    background: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 10,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                  }}
                >
                  <img
                    src={item.icon}
                    alt=""
                    style={{ width: "40px", height: "40px", objectFit: "cover", }}
                  />
                </div>
                <p
                  className="fw-bold text-secondary text-center w-75"
                  style={{ fontSize: "14px" }}
                >
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div
          className="col-12 col-md-6 col-lg-6 pt-5 pt-lg-4 ps-1 pe-4 pe-lg-0 text-center text-light custom-why-sorted-trips-right-part"
          style={{ backgroundColor: "#249acd" }}
        >
          <h2 className="mb-3 fs-3 fw-bold custom-why-sorted-trips-right-part-header">WHY SORTED TRIPS?</h2>
          <p className="mb-5 custom-why-sorted-trips-right-part-para"
            style={{
              textAlign: "justify",
              fontSize: "14px",
              fontFamily: "nexaLight",
            }}
            dangerouslySetInnerHTML={{ __html: data }}
          >
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhySortedTrips;
